import {Injectable} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {from, Observable} from "rxjs";
import {UcRegisterHistoryModalComponent} from "./uc-register-history-modal.component";
import {ReportOnOffBoardResultDto} from "../../../../../generated-model/model";

@Injectable({providedIn: 'root'})
export class UcRegisterHistoryModalService {


  constructor(private modalService: NgbModal) {
  }

  open(item: ReportOnOffBoardResultDto): Observable<boolean> {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(UcRegisterHistoryModalComponent, {fullscreen: true});
    modalRef.componentInstance.item = item;
    return from(modalRef.result)
  }
}
